import React, { useEffect } from 'react';

export type ModalProps = {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  className?: string;
  footer?: React.ReactNode;
};

const Modal: React.FC<ModalProps> = ({ open, onClose, title, children, className = '', footer }) => {
  useEffect(() => {
    if (!open) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div className="fixed inset-0 bg-black bg-opacity-10 transition-opacity" onClick={onClose} />
      {/* Modal content */}
      <div
        className={`relative bg-white rounded-2xl shadow-2xl max-w-xl w-full mx-4 p-0 z-10 border border-gray-100 ${className}`}
        role="dialog"
        aria-modal="true"
      >
        <div className="flex items-center justify-between px-6 pt-6 pb-3">
          {title && <h2 className="text-xl font-bold">{title}</h2>}
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 focus:outline-none text-2xl p-1 rounded-full transition"
            aria-label="Close modal"
          >
            <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path d="M6 18L18 6M6 6l12 12"/></svg>
          </button>
        </div>
        <div className="border-t border-gray-200" />
        <div className="px-6 py-6">{children}</div>
        <div className="border-t border-gray-200" />
        <div className="px-6 py-4 flex justify-end gap-2">{footer}</div>
      </div>
    </div>
  );
};

export default Modal;
